/**
 * URLs de imagen de producto para la carta.
 *
 * Las fotos nuevas viven en Supabase Storage como archivo público
 * (`/storage/v1/object/public/...`). El nombre incluye un timestamp, así que
 * el archivo no se reescribe. La carta pide una copia más chica por el
 * endpoint de transformación y, si esa URL falla, vuelve al archivo original.
 */

const MARCADOR_OBJETO_PUBLICO = "/storage/v1/object/public/";
const MARCADOR_RENDER = "/storage/v1/render/image/public/";

/**
 * @param {string|null|undefined} url
 * @returns {boolean}
 */
export function esImagenStorageSupabase(url) {
  if (!url || typeof url !== "string") {
    return false;
  }
  try {
    const parsed = new URL(url);
    return (
      parsed.pathname.includes(MARCADOR_OBJETO_PUBLICO) &&
      !parsed.pathname.includes(MARCADOR_RENDER)
    );
  } catch {
    return false;
  }
}

/**
 * @param {string} url
 * @param {number} width
 * @returns {string}
 */
export function urlImagenTransformada(url, width) {
  const parsed = new URL(url);
  parsed.pathname = parsed.pathname.replace(
    MARCADOR_OBJETO_PUBLICO,
    MARCADOR_RENDER
  );
  parsed.searchParams.set("width", String(width));
  parsed.searchParams.set("quality", "75");
  parsed.searchParams.set("resize", "contain");
  return parsed.toString();
}

/**
 * @param {string|null|undefined} url
 * @param {"tarjeta"|"modal"} [variante]
 * @returns {{ src: string, srcSet?: string, sizes?: string, original: string } | null}
 */
export function resolverImagenProducto(url, variante = "tarjeta") {
  const original = url != null ? String(url).trim() : "";
  if (!original) {
    return null;
  }

  if (!esImagenStorageSupabase(original)) {
    return { src: original, original };
  }

  if (variante === "modal") {
    return {
      src: urlImagenTransformada(original, 800),
      original,
    };
  }

  const chica = urlImagenTransformada(original, 320);
  const mediana = urlImagenTransformada(original, 480);
  return {
    src: mediana,
    srcSet: `${chica} 320w, ${mediana} 480w`,
    sizes: "(min-width: 1200px) 300px, (min-width: 768px) 46vw, 92vw",
    original,
  };
}
